import { Permission } from '../../enums';
import { MenuItem } from '../../interfaces';

export const menuItems: MenuItem[] = [
    {
        title: 'Home',
        icon: 'home',
        link: '/home',
        permissions: [Permission.Home],
    },
    {
        title: 'Location',
        icon: 'location',
        link: '/location',
        permissions: [],
        hideForSubAgent: true,
    },
    {
        title: 'Wallet Transfer',
        icon: 'wallet-money',
        link: 'send-money',
        permissions: [],
    },
    {
        title: 'Find Super Agent',
        icon: 'star',
        useFontIcon: true,
        panelId: 'find-super-agent',
        permissions: [],
        hideForSuperAgent: true,
    },
    {
        title: 'Top-Up Info',
        icon: 'bank-icon',
        link: 'top-up-info',
        permissions: [],
    },
];

export const lowerMenuItems: MenuItem[] = [
    {
        title: 'User Management',
        icon: 'user-management',
        link: 'user-management',
        permissions: [],
        hideForSubAgent: true,
    },
];
